(function (angular) {
    angular.module('app').config(["$routeProvider", function ($routeProvider) {
        $routeProvider.when('/admin/fake-login', {
            templateUrl: 'classification/pages/admin/FakeLogin/FakeLogin.tmpl.html',
            controller: 'FakeLoginCtrl'

        });
    }]);
})(angular);